export default function applyAriaHiddenToImg(block) {
  const imgIcon = block.querySelector('img');

  if (imgIcon) {
    imgIcon.ariaHidden = true;
  }
}
